



function faqCollapse() {
        

    if (jQuery(".faq-tpl-ew12").length) {

        var comeshpsec            = ".faq-tpl-ew12";



        jQuery('.faq-tpl-ew12 .card .collapse').on('show.bs.collapse', function (evt) {

            var x = evt.currentTarget;

            jQuery(".faq-tpl-ew12 .card").removeClass("opencard-m7");
            jQuery(x).parents(".card").addClass("opencard-m7");
        })



        jQuery('.faq-tpl-ew12 .card .collapse').on('hide.bs.collapse', function (evt) {

            var x = evt.currentTarget;

            jQuery(x).parents(".card").removeClass("opencard-m7");
        })
    }
};





export {faqCollapse}